import { useState } from 'react';
import apiService from '../../../../services/apiService';
import { useTenant } from '../../../../contexts/TenantContext';

const ThrowballVerifyCertificates = () => {
  const { siteSettings } = useTenant();
  const [serialNumber, setSerialNumber] = useState('');
  const [verifyResult, setVerifyResult] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    const trimmedSerial = serialNumber.trim();

    if (!trimmedSerial) {
      setVerifyResult({ success: false, message: 'Please enter a serial number' });
      return;
    }

    setLoading(true);
    setVerifyResult(null);

    try {
      const response = await apiService.post('/public/verify-certificate', { serial_number: trimmedSerial });
      const data = response.data;

      if (data.success && data.verified) {
        setVerifyResult({
          success: true,
          data: data.data
        });
        setShowPopup(true);
      } else {
        setVerifyResult({
          success: false,
          message: data.message || 'Certificate verification failed'
        });
      }
    } catch (error) {
      console.error('Error verifying certificate:', error);
      setVerifyResult({
        success: false,
        message: 'Unable to verify certificate. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !loading) {
      handleVerify();
    }
  };

  return (
    <section className="tb-page-section tb-verify-section">
      <div className="tb-container">
        {/* Top Banner */}
        <div className="tb-page-banner">
          <img src={siteSettings?.page_banners?.['verify-certificates'] || '/theme/assets/images/banner-3.jpg'} alt="Verify Certificates Banner" />
        </div>

        {/* Page Content */}
        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">Verify Certificates</h1>
            <span className="tb-mini-line"></span>
          </div>

          <div className="tb-verify-container">
            <div className="tb-verify-card">
              <div className="tb-verify-title">Verify Serial Number</div>

              <div className="tb-verify-field">
                <input
                  type="text"
                  placeholder="Enter Serial No..."
                  className="tb-verify-input"
                  value={serialNumber}
                  onChange={(e) => setSerialNumber(e.target.value)}
                  onKeyDown={handleKeyDown}
                  disabled={loading}
                />
              </div>

              <button
                type="button"
                className="tb-verify-submit"
                onClick={handleVerify}
                disabled={loading}
                style={{ opacity: loading ? 0.7 : 1 }}
              >
                {loading ? 'Checking...' : 'Check'}
              </button>

              {verifyResult && !verifyResult.success && (
                <div className="tb-verify-result error">
                  <i className="ri-close-circle-line"></i> {verifyResult.message || 'Invalid Serial Number'}
                </div>
              )}

              {verifyResult && verifyResult.success && !showPopup && (
                <div className="tb-verify-result success">
                  <i className="ri-checkbox-circle-line"></i> Certificate Verified!
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Popup */}
      {showPopup && verifyResult?.success && (
        <div className="tb-popup-overlay" onClick={closePopup}>
          <div className="tb-popup-box" onClick={(e) => e.stopPropagation()}>
            <button className="tb-popup-close" onClick={closePopup}>
              &times;
            </button>

            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <h3 className="tb-popup-title" style={{ color: '#c00f15', margin: 0 }}>
                Profile Details
              </h3>
            </div>

            <table className="tb-popup-table">
              <tbody>
                <tr>
                  <td><strong>Name</strong></td>
                  <td>{verifyResult.data.holder_name}</td>
                </tr>
                {verifyResult.data.holder_dob && (
                  <tr>
                    <td><strong>DOB</strong></td>
                    <td>{verifyResult.data.holder_dob}</td>
                  </tr>
                )}
                {verifyResult.data.father_name && (
                  <tr>
                    <td><strong>Father Name</strong></td>
                    <td>{verifyResult.data.father_name}</td>
                  </tr>
                )}
                {verifyResult.data.title && (
                  <tr>
                    <td><strong>Tournaments Name</strong></td>
                    <td>{verifyResult.data.title}</td>
                  </tr>
                )}
                {verifyResult.data.position && (
                  <tr>
                    <td><strong>Team Position</strong></td>
                    <td>{verifyResult.data.position}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <style>{`
        .tb-verify-result.success {
          color: #28a745;
          background: #d4edda;
          border: 1px solid #c3e6cb;
          padding: 12px 20px;
          border-radius: 8px;
          margin-top: 15px;
          display: flex;
          align-items: center;
          gap: 8px;
          justify-content: center;
          font-weight: 500;
        }
        .tb-verify-result.error {
          color: #dc3545;
          background: #f8d7da;
          border: 1px solid #f5c6cb;
          padding: 12px 20px;
          border-radius: 8px;
          margin-top: 15px;
          display: flex;
          align-items: center;
          gap: 8px;
          justify-content: center;
          font-weight: 500;
        }
        .tb-popup-table {
          width: 100%;
          border-collapse: collapse;
        }
        .tb-popup-table td {
          padding: 10px 12px;
          border-bottom: 1px solid #eee;
        }
        .tb-popup-table tr:last-child td {
          border-bottom: none;
        }
        .tb-popup-table td:first-child {
          width: 40%;
          color: #666;
          font-size: 14px;
        }
        .tb-popup-table td:last-child {
          color: #333;
          font-weight: 500;
        }
      `}</style>
    </section>
  );
};

export default ThrowballVerifyCertificates;
